import { render, staticRenderFns } from "./transpet.vue?vue&type=template&id=4b5e6541&scoped=true"
import script from "./transpet.vue?vue&type=script&lang=js"
export * from "./transpet.vue?vue&type=script&lang=js"
import style0 from "./transpet.vue?vue&type=style&index=0&id=4b5e6541&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5e6541",
  null
  
)

export default component.exports